import { Injectable, HostListener, Output, EventEmitter } from '@angular/core';
import {
  VIEWPORT_MAX_SIZE,
  VIEWPORT_MIN_SIZE
} from '@shared/constants/viewport-standards';
@Injectable({
  providedIn: 'root'
})
export class ViewportService {
  desktop;
  tablet;
  mobile;

  @Output()
  updatingView: EventEmitter<any> = new EventEmitter();

  constructor() {}

  checkViewSizes() {
    this.desktop = window.outerWidth >= VIEWPORT_MIN_SIZE.DESKTOP;
    this.tablet =
      window.outerWidth <= VIEWPORT_MAX_SIZE.TABLET &&
      window.outerWidth > VIEWPORT_MIN_SIZE.MOBILE;
    this.mobile = window.outerWidth <= VIEWPORT_MAX_SIZE.MOBILE;
    this.updatingView.emit();
  }

  isDesktop() {
    return this.desktop;
  }

  isTablet() {
    return this.tablet;
  }

  isMobile() {
    return this.mobile;
  }
}
